import React from 'react'

import PropTypes from 'prop-types'

import styles from './blog-post-card4.module.css'

const BlogPostCard4 = (props) => {

  const Description = props.description

  return (
    <div
      className={` ${styles['blog-post-card']} ${styles[props.rootClassName]} `}
      style={{
        flexDirection: props.id%2 ? 'row':'row-reverse'
      }}
    >
      <img
        alt={props.image_alt}
        src={props.image_src}
        className={styles['image']}
      />
      <div className={styles['container']}>
        <span className={styles['text']}>{props.date}</span>
        <span className={styles['text1']}><Description /></span>
        <div className={styles['separator']}></div>
        <span className={styles['text2']}>{props.label}</span>
      </div>
    </div>
  )
}

BlogPostCard4.defaultProps = {
  description: ()=>{
    return <p>Hello</p>
  },
  label: 'Food & Drink',
  rootClassName: '',
  date: 'JULY 24',
  image_src:
    'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDF8fHZlbmljZXxlbnwwfHx8fDE2MjYyNzIyOTA&ixlib=rb-1.2.1&w=1000',
  image_alt: 'image',
}

BlogPostCard4.propTypes = {
  description: PropTypes.string,
  label: PropTypes.string,
  rootClassName: PropTypes.string,
  date: PropTypes.string,
  image_src: PropTypes.string,
  image_alt: PropTypes.string,
}

export default BlogPostCard4